import React, { FC } from "react";

const ChevronsDown: FC = () => {
    return (
        <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.60351 0.350804L1.35359 1.60072C1.15832 1.79599 1.15832 2.11257 1.35359 2.30783L7.04272 7.99696C7.23798 8.19222 7.55456 8.19222 7.74982 7.99696L13.439 2.30783C13.6342 2.11257 13.6343 1.79608 13.439 1.60082L12.1838 0.345591C11.9916 0.153357 11.6811 0.150089 11.4847 0.338053L7.33166 4.31246L3.30797 0.348184C3.1123 0.155398 2.79774 0.156568 2.60351 0.350804ZM2.28737 5.62506L1.03745 6.87498C0.84219 7.07024 0.84219 7.38682 1.03745 7.58208L6.72659 13.2712C6.92185 13.4665 7.23843 13.4665 7.43369 13.2712L13.1228 7.58208C13.3181 7.38682 13.3182 7.07033 13.1229 6.87507L11.8677 5.61984C11.6755 5.42761 11.365 5.42434 11.1686 5.6123L7.01553 9.58671L2.99184 5.62244C2.79616 5.42965 2.48161 5.43082 2.28737 5.62506Z"
                fill="#E30613"
            />
        </svg>
    );
};

export default React.memo(ChevronsDown);
